import React from 'react';
import { Layout } from '../../Layout';
import { Navbar } from './Navbar';
import { SocialIcons } from './SocialIcons';
import Background from './Background';

interface Props {
    children: React.ReactNode;
}

export const DappLayout: React.FC<Props> = ({ children }: Props) => {
    return (
        <div>
            <Background />
            <div tw="z-10 py-32 min-h-screen">
                <Layout>
                    <div tw="w-full md:pt-8">
                        <Navbar />
                        {children}
                        <SocialIcons />
                    </div>
                </Layout>
            </div>
        </div>
    );
};
